import { useState, useEffect } from 'react';
import { PANEL_TEXT_SIZE, readStoredPercent } from '../utils/textSizeRange';

/**
 * usePanelZoom — shared text-magnifier state for the reference panels
 * (Compendium / Research / Bookmarks, and any future panel).
 *
 * Mirrors the sidebar zoom pattern (persisted % value + <TextSizeStepper> +
 * a `zoom` scale on the content wrapper), but with ONE shared value across all
 * panels so they magnify identically and new panels inherit it for free.
 *
 * The default sits above 100% so panel text is visibly larger out of the box
 * (Item 2); the stepper tunes it and persists. Out-of-range saved values are
 * ignored (clamp validation), same as the sidebar. Values inside the range,
 * including the old 170 cap, load unchanged.
 */
export const PANEL_ZOOM = PANEL_TEXT_SIZE;

const STORAGE_KEY = 'brainstormy.jetage.panelZoom';

export function usePanelZoom() {
  const [zoom, setZoom] = useState(() => (
    readStoredPercent(localStorage.getItem(STORAGE_KEY), PANEL_ZOOM)
  ));

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, String(zoom));
  }, [zoom]);

  return [zoom, setZoom];
}

export default usePanelZoom;
